import React from "react";
import PropTypes from "prop-types";
import sourceflowEnums from "@/sourceflow.enums";

/**
 *
 * @param title
 * @param description
 * @param url
 * @param image
 * @param author
 * @param datePublished
 * @param dateModified
 * @param publisherName
 * @param publisherLogo
 * @returns {JSX.Element}
 * @constructor
 */
export default function BlogPostingSchema({
  title,
  description,
  url,
  image,
  author,
  datePublished,
  dateModified,
  publisherName,
  publisherLogo,
}) {
  let schemaData = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    headline: title, // "Newest Attorney Joins Our Team"
    author: author ?? publisherName ?? null, // "Example Law Firm"
    description, // "Our newest lawyer has joined the team. Learn more about our newest attorney here."
    url,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": url, // "https://www.examplelaw.com/blog/newest-attorney/"
    },
    datePublished, // "2018-11-21",
    dateModified: dateModified ?? datePublished, // "2019-02-27"
    publisher: {
      "@type": "Organization",
      name: publisherName, // "Example Law Firm"
      logo: {
        "@type": "ImageObject",
        url: publisherLogo, // "https://www.examplelaw.com/wp-content/themes/examplelaw/assets/logo.png"
      },
    },
    image: image
      ? {
          "@type": "ImageObject",
          url: image, // "https://www.examplelaw.com/wp-content/themes/examplelaw/assets/featured-image.png"
        }
      : {},
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }} />;
}

BlogPostingSchema.defaultProps = {
  title: null,
  author: null,
  description: null,
  url: null,
  image: null,
  publisherName: null,
  publisherLogo: null,
};

BlogPostingSchema.propTypes = {
  title: PropTypes.string,
  author: PropTypes.string,
  description: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string,
  publisherName: PropTypes.string,
  publisherLogo: PropTypes.string,
};
